import { ComponentType } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { ActivatedRoute } from '@angular/router';
import { getQuery } from '../../shared/utils';
import { VersicherungsnehmerListDialogComponent } from '../components/partner/partner-list-dialog/partner-list-dialog.component';
import { PartnerComponent } from '../components/partner/partner.component';
import { IPartnerRequest } from '../models/partnerrequest';
import { PartnerService } from './partner.service';

abstract class PartnerListDialogService {

  constructor(private dialog: MatDialog, private component: ComponentType<any>) { }

  openDialog(event: any, partnerComponent: PartnerComponent, showEinzelunternehmen: boolean = false, validateAlter: (alter: Date) => boolean) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    dialogConfig.height = '80%';

    dialogConfig.data = {
      showEinzelunternehmen: showEinzelunternehmen,
      validateAlter: validateAlter
    };

    const dialogRef = this.dialog.open(this.component, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadPartner(result, partnerComponent);
      }
    });
    event.preventDefault();
  }

  abstract loadPartner(result: number, partnerComponent: PartnerComponent): void;
}

@Injectable({
  providedIn: 'root'
})
export class VersicherungsnehmerListDialogService extends PartnerListDialogService {

  constructor(dialog: MatDialog, private route: ActivatedRoute, private partnerService: PartnerService) {
    super(dialog, VersicherungsnehmerListDialogComponent);
  }

  loadPartner(result: number, partnerComponent: PartnerComponent) {
    this.partnerService.getVersicherungsnehmer({
      PartnerId: result
    } as IPartnerRequest, getQuery()).subscribe(data => {
      partnerComponent.setPartner(data);
      partnerComponent.partnerChangedEvent.emit();
    });
  }
}
